<template>
    <!-- <svg viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_580_5736)">
            <path
                d="M20.6367 3H4.63672C2.97986 3 1.63672 4.34315 1.63672 6V15C1.63672 16.6569 2.97986 18 4.63672 18H20.6367C22.2936 18 23.6367 16.6569 23.6367 15V6C23.6367 4.34315 22.2936 3 20.6367 3Z"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                d="M7.63672 21H17.6367"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
        </g>
        <defs>
            <clipPath id="clip0_580_5736">
                <rect
                    width="24"
                    height="24"
                    fill="none"
                    transform="translate(0.636719)"
                />
            </clipPath>
        </defs>
    </svg> -->
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_580_5736)">
            <path
                d="M20 1H4C2.34315 1 1 2.52223 1 4.4V14.6C1 16.4778 2.34315 18 4 18H20C21.6569 18 23 16.4778 23 14.6V4.4C23 2.52223 21.6569 1 20 1Z"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                d="M6 23H18"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
        </g>
        <defs>
            <clipPath id="clip0_580_5736">
                <rect width="24" height="24" fill="white" />
            </clipPath>
        </defs>
    </svg>
</template>
